export const ROW_ESTIMATE_PX = 48;
export const OVERSCAN = 10;

/**
 * Id of the structural checkbox selection column, shared by `buildColumns()`,
 * `useColumnPreferences`'s `pinnedIds`, and the `ColumnPicker`'s pinned-id list —
 * a single source of truth instead of the `'select'` literal duplicated per call site.
 */
export const SELECT_COLUMN_ID = 'select';

/** Column IDs that are gated behind canViewCosts. */
export const COST_COLUMN_IDS: ReadonlySet<string> = new Set([
  'catalogPrice',
  'rent',
  'exposureCost',
  'additionalCosts',
  'discountedPrice',
  'lastMinutePrice',
  'starterPrice',
  'productionCost',
  'installationCost',
  'dismantlingCost',
  'clientProduction',
  'clientInstallation',
  'clientDismantling',
  'clientAdditionalFees',
]);

/**
 * Column IDs that are gated behind canViewSupplierDetails
 * (catalog-column-filter-parity — `supplier`/`supplierNumber` were previously
 * ungated by mistake, showing supplier data regardless of permission).
 * `supplierContactInfo`/`supplierEmail`/`supplierPhone` columns were removed
 * entirely (CU-86cb1nq7h, client request) — no longer exist to gate.
 */
export const SUPPLIER_DETAIL_COLUMN_IDS: ReadonlySet<string> = new Set([
  'supplier',
  'supplierNumber',
]);

// catalogPrice is visible by default; all other cost columns are hidden by default.
const HIDDEN_COST_COLUMN_IDS = [...COST_COLUMN_IDS].filter((id) => id !== 'catalogPrice');

/**
 * IDs of all columns hidden by default for first-visit users (no stored
 * `ooh:inventory:hiddenColumns` preference yet). Passed as `defaultHiddenIds` to the
 * shared `useColumnPreferences` hook. Covers REQ-2.24.
 */
export const DEFAULT_HIDDEN_COLUMNS: ReadonlySet<string> = new Set([
  'grwId',
  'material',
  'notes',
  'locationDescription',
  'wfContactPerson',
  'multiformat',
  'tags',
  // ─── Reverse-parity columns (catalog-column-filter-parity) ───
  'format',
  'roadNumber',
  ...HIDDEN_COST_COLUMN_IDS,
]);
